<mat-card appearance="outlined" [@fadeInOut]  style="margin-left: -14px;">
    <mat-card-content> 
        <div class="main-container">
            <div #dataSourceCard >
                <mat-button-toggle-group [value]="ingestTransformConfigViewModel.dataConnectorTypeIngest" >
                    <ng-container *ngFor="let connectorIngest of dataConnectorsIngest">
                        <mat-button-toggle 
                            [value]="connectorIngest.dataConnectorTypeIngest" 
                            (click)="onDataConnectorSelected(connectorIngest)">
                            {{ connectorIngest.title }}
                        </mat-button-toggle>
                    </ng-container>
                </mat-button-toggle-group>
            </div>
            <div>
                <button mat-button (click)="viewIngestTransformConfigJson()" class="big-icon-btn">
                    <mat-icon class="primary-color-icon" style="margin-right:1px;">article</mat-icon>View JSON
                </button>
                <a mat-button [href]="aboutlink" target="_blank">
                    <!-- <i class="fa-solid fa-question primary-color-icon" style="margin-right: 5px;font-weight: bold;"></i>About... -->
                     <button style="color: rgb(247, 246, 240)" mat-button >
        <mat-icon class="big-help-icon " style="margin-right: 1px;">help</mat-icon>
        About...
      </button>
                </a>
            </div>
        </div>
    </mat-card-content>
</mat-card>
<div style="display: flex;flex-wrap: wrap;align-items: center; ">
    <div style="margin-right: 10px;">
        <mat-card appearance="outlined" [@fadeInOut] >
            <mat-card-content [ngSwitch]="ingestTransformConfigViewModel.dataConnectorTypeIngest">
                <app-type-data-connector *ngSwitchCase="dataConnectorTypeIngest.DataTypeConverter"  [dataTransformConfigViewModel]="viewModel"
                [dataSourceType]="viewModel.dataSourceType" >
                </app-type-data-connector>
                <app-duplicate-data-connector *ngSwitchCase="dataConnectorTypeIngest.DeduplicateRows" [dataTransformConfigViewModel]="viewModel"
                [dataSourceType]="viewModel.dataSourceType"  >
                </app-duplicate-data-connector>

                <app-durationcalcs-data-connector *ngSwitchCase="dataConnectorTypeIngest.DurationCalc" [dataTransformConfigViewModel]="viewModel"
                [dataSourceType]="viewModel.dataSourceType" [ingestConfig]="ingestConfig" >
                </app-durationcalcs-data-connector>

                <app-parameter-data-connector *ngSwitchCase="dataConnectorTypeIngest.GeneralParameters" [dataTransformConfigViewModel]="viewModel"
                [dataSourceType]="viewModel.dataSourceType" >
                </app-parameter-data-connector>
            </mat-card-content>
        </mat-card>
    </div>
    <div style="flex: 1; min-width: 300px; margin-right: 10px;">
        <div style="color: red; font-size: 12pt; height: 100%; width: 100%; overflow: auto;">
            <pre>
                {{json}}
            </pre>
        </div>
        <!-- <mat-card class="json-card" appearance="outlined">
          <mat-card-header>
            <mat-card-title style="font-size: 12px;">Sample JSON Config</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div style="color: red; font-size: 12pt; height: 100%; width: 100%; overflow: auto;">
              <pre>
                  {{json}}
              </pre>
            </div>
          </mat-card-content>
        </mat-card> -->
      </div>
</div>